import { LoadingSpinner, Text } from "@clipboard-health/ui-components";
import { Stack, type SxProps, type Theme } from "@mui/material";

interface LoadingMoreIndicatorProps {
  sx?: SxProps<Theme>;
}

export function LoadingMoreIndicator(props: LoadingMoreIndicatorProps) {
  const { sx } = props;

  return (
    <Stack spacing={5} alignItems="center" sx={sx}>
      <LoadingSpinner size="medium" variant="primary" />

      <Text color={(theme) => theme.palette.text.secondary}>Loading more shifts...</Text>
    </Stack>
  );
}
